import { components } from "react-select";

const Option = ({ children, ...props }) => (
	<components.Option className="advanced-select-option" {...props}>
		{children}
	</components.Option>
);

export default Option;
